import SHAREBOX_S32_CHECK_IN_STEPS from './s32';

const SHAREBOX_M28_CHECK_IN_STEPS = SHAREBOX_S32_CHECK_IN_STEPS;

export default SHAREBOX_M28_CHECK_IN_STEPS;
